import { initAllModules } from './functions.js';

import './InfocardCarouselModule.js';
import './elements/AjaxFormElement.js';
import './elements/ConditionalRenderElement.js';
import './elements/CarouselElement.js';
import './elements/NewSelectorElement.js';
import './elements/EasepickElement.js';
import './elements/NumberElement.js';
import './elements/MySelectionElement.js';
import './elements/CalendarElement.js';
import './elements/BigpackElement.js';
import './elements/WaitinglistFormElement.js';
import './elements/SyncronizeSwiperElement.js';
import './elements/PacklistDesktopElement.js';
import './elements/CleanErrorsElement.js';
import './elements/MakeMeDateElement.js';
import './modules/GlobalModule.js';
import './modules/ExplistModule.js';
import './modules/TabsModule.js';
import './modules/NumberOnlyInputModule.js';
import './elements/DealerLocatorElement.js';
import './elements/ScrollGradientElement.js';
import './elements/LanguageSwitcherElement.js';

window.modules = window.modules || {}

Object.assign(window.modules, {
});

window.addEventListener('DOMContentLoaded', function() {
    initAllModules();
});

window.addEventListener('load', function() {
   
});